import { render, staticRenderFns } from "./sequence-review-step.vue?vue&type=template&id=3842731c&scoped=true"
import script from "./sequence-review-step.vue?vue&type=script&lang=js"
export * from "./sequence-review-step.vue?vue&type=script&lang=js"
import style0 from "./sequence-review-step.vue?vue&type=style&index=0&id=3842731c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3842731c",
  null
  
)

export default component.exports